"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactHookForm = require("react-hook-form");

var _uuid = require("uuid");

var _services = require("@alycecom/services");

var _query = require("@reduxjs/toolkit/query");

var _ramda = require("ramda");

var _hooks = require("@alycecom/hooks");

var _yup = require("yup");

var _yup2 = require("@hookform/resolvers/yup");

var _prospectingContacts = require("../../constants/prospectingContacts.schemas");

var _commonData = require("../../../../../Shared/store/commonData/commonData.selector");

var _providers = require("../../../../providers");

var _useTrackGiftingFlow = require("../../../../hooks/useTrackGiftingFlow");

var _fixedCacheKeys = require("../../../../constants/fixedCacheKeys");

var _hooks2 = require("../../../../hooks");

var _commonData2 = require("../../../../../Shared/store/commonData");

var _sendAs = require("../../../../../CreateGift/store/send-as/send-as.selector");

var _user = require("../../../../../Shared/store/user/user.selectors");

var _ContactTableController = _interopRequireDefault(require("./ContactTableController"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ContactsPreviewForm = function ContactsPreviewForm(_ref) {
  var children = _ref.children;

  var _GlobalMessage$useGlo = _services.GlobalMessage.useGlobalMessage(),
      showGlobalMessage = _GlobalMessage$useGlo.showGlobalMessage;

  var _useGiftingFlowSteps = (0, _hooks2.useGiftingFlowSteps)(),
      goToNextStep = _useGiftingFlowSteps.goToNextStep;

  var _useGiftingFlowContex = (0, _providers.useGiftingFlowContext)(),
      campaignId = _useGiftingFlowContex.campaignId,
      onBatchCreated = _useGiftingFlowContex.onBatchCreated;

  var users = (0, _reactRedux.useSelector)(_sendAs.getSendAsList);
  var currentUserEmail = (0, _reactRedux.useSelector)(_user.getUserEmail);

  var _useGetCampaignByIdQu = (0, _services.useGetCampaignByIdQuery)(campaignId || _query.skipToken),
      campaign = _useGetCampaignByIdQu.data;

  var countries = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    var _campaign$countryIds;

    return (0, _commonData.makeGetCountriesByIds)((_campaign$countryIds = campaign === null || campaign === void 0 ? void 0 : campaign.countryIds) !== null && _campaign$countryIds !== void 0 ? _campaign$countryIds : []);
  }, [campaign]));
  var availableCountriesCode = (0, _react.useMemo)(function () {
    return countries.map(function (country) {
      return country.code;
    });
  }, [countries]);
  var availableUserEmails = (0, _react.useMemo)(function () {
    return users.map(function (user) {
      return user.email;
    });
  }, [users]);
  var trackGiftingFlowContactTableIsOpened = (0, _useTrackGiftingFlow.useGiftingFlowContactTableIsOpened)();
  var trackGiftingFlowContactsStepNextButtonClick = (0, _useTrackGiftingFlow.useGiftingFlowContactsStepNextButtonClick)();
  var customFields = (0, _reactRedux.useSelector)(_commonData2.CommonData.selectors.getCustomFields);

  var _useCreateProspecting = (0, _services.useCreateProspectingBatchMutation)(),
      _useCreateProspecting2 = (0, _slicedToArray2.default)(_useCreateProspecting, 2),
      createProspectingBatch = _useCreateProspecting2[0],
      _useCreateProspecting3 = _useCreateProspecting2[1],
      data = _useCreateProspecting3.data,
      isCreateBatchLoading = _useCreateProspecting3.isLoading,
      createBatchError = _useCreateProspecting3.error,
      resetCreateProspectingBatch = _useCreateProspecting3.reset;

  var _useUploadProspecting = (0, _services.useUploadProspectingContactsFileMutation)({
    fixedCacheKey: _fixedCacheKeys.GIFTING_FLOW_CACHE_KEYS.UPLOAD_CONTACTS_FILE,
    selectFromResult: function selectFromResult(result) {
      var _result$data;

      return _objectSpread(_objectSpread({}, result), {}, {
        data: (_result$data = result.data) !== null && _result$data !== void 0 ? _result$data : {
          contacts: [],
          errors: undefined
        }
      });
    }
  }),
      _useUploadProspecting2 = (0, _slicedToArray2.default)(_useUploadProspecting, 2),
      _useUploadProspecting3 = _useUploadProspecting2[1],
      _useUploadProspecting4 = _useUploadProspecting3.data,
      uploadedContacts = _useUploadProspecting4.contacts,
      uploadedContactsErrors = _useUploadProspecting4.errors,
      resetUploadProspectingContactsFile = _useUploadProspecting3.reset;

  var contactsSchema = (0, _prospectingContacts.prepareFormData)(customFields, currentUserEmail);
  var contactsForm = (0, _yup.object)().shape({
    [_prospectingContacts.ContactStepField.contacts]: contactsSchema
  });
  var contactsFormResolver = (0, _yup2.yupResolver)(contactsForm);
  var preselectedCountry = countries.length === 1 ? countries[0].code : '';

  var _useForm = (0, _reactHookForm.useForm)({
    mode: 'all',
    resolver: contactsFormResolver,
    defaultValues: {
      contacts: [{
        id: (0, _uuid.v4)(),
        firstName: '',
        lastName: '',
        email: '',
        company: '',
        country: preselectedCountry,
        customFields: {},
        sendAsEmail: currentUserEmail
      }]
    },
    context: {
      availableCountriesCode,
      availableUserEmails
    }
  }),
      handleSubmit = _useForm.handleSubmit,
      resetField = _useForm.resetField,
      control = _useForm.control,
      register = _useForm.register,
      unregister = _useForm.unregister,
      setError = _useForm.setError,
      _useForm$formState = _useForm.formState,
      isDirty = _useForm$formState.isDirty,
      isValid = _useForm$formState.isValid;

  (0, _react.useEffect)(function () {
    if (uploadedContacts.length) {
      register(_prospectingContacts.ContactStepField.contacts);
      resetField(_prospectingContacts.ContactStepField.contacts, {
        defaultValue: (0, _ramda.clone)(uploadedContacts)
      });

      if (uploadedContactsErrors) {
        (0, _hooks.applyManualErrors)(setError, uploadedContactsErrors);
      }

      resetUploadProspectingContactsFile();
    }
  }, [uploadedContacts, uploadedContactsErrors, setError, register, resetField, resetUploadProspectingContactsFile]);
  (0, _react.useEffect)(function () {
    if (createBatchError && (0, _services.isValidationError)(createBatchError)) {
      var _createBatchError$dat, _createBatchError$dat2, _createBatchError$dat3;

      (0, _hooks.applyManualErrors)(setError, (_createBatchError$dat = createBatchError === null || createBatchError === void 0 ? void 0 : (_createBatchError$dat2 = createBatchError.data) === null || _createBatchError$dat2 === void 0 ? void 0 : (_createBatchError$dat3 = _createBatchError$dat2.error) === null || _createBatchError$dat3 === void 0 ? void 0 : _createBatchError$dat3.errors) !== null && _createBatchError$dat !== void 0 ? _createBatchError$dat : {});
      resetCreateProspectingBatch();
    }
  }, [setError, createBatchError, resetCreateProspectingBatch]);
  (0, _react.useEffect)(function () {
    if (data !== null && data !== void 0 && data.giftBatchId) {
      onBatchCreated(data.giftBatchId);
    }
  }, [data, onBatchCreated]);
  var onSubmit = handleSubmit(function (_ref2) {
    var contacts = _ref2.contacts;

    if (campaignId) {
      createProspectingBatch({
        campaignId,
        body: {
          contacts
        }
      }).unwrap().then(function () {
        goToNextStep();
        showGlobalMessage({
          type: _services.MessageType.Success,
          text: "".concat(contacts.length, " contacts are successfully created")
        });
      });
      trackGiftingFlowContactsStepNextButtonClick(contacts);
    }
  });
  (0, _react.useEffect)(function () {
    trackGiftingFlowContactTableIsOpened();
  }, [trackGiftingFlowContactTableIsOpened]);
  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: onSubmit
  }, /*#__PURE__*/_react.default.createElement(_ContactTableController.default, {
    control: control,
    loading: isCreateBatchLoading,
    unregister: unregister,
    countries: countries
  }), typeof children === 'function' ? children({
    isLoading: isCreateBatchLoading,
    isDirty,
    isValid
  }) : children);
};

var _default = /*#__PURE__*/(0, _react.memo)(ContactsPreviewForm);

exports.default = _default;